<template>
  <div
    v-if="modalOpened"
    class="fixed inset-0 flex items-center justify-center z-50 rounded-[10px]"
  >
    <!-- Modal Overlay -->
    <div
      class="fixed inset-0 bg-[#80808086] bg-opacity-50 rounded-[10px]"
      @click="closeModal"
    ></div>

    <!-- Modal Content -->
    <div
      class="relative bg-white w-[450px] max-h-[690px] rounded-[10px] shadow-lg z-10 flex flex-col"
    >
      <!-- Modal Header -->
      <div
        class="bg-[#9A247B] text-white p-[20px] py-[12px] pr-[10px] flex justify-between items-center rounded-t-[10px]"
      >
        <h3 class="s !text-[14px]">รายละเอียดเพิ่มเติม</h3>
        <button
          @click="closeModal"
          class="text-white hover:text-gray-200 bg-white rounded-full"
        >
          <CloseIcon class="w-6 h-6 text-primary" />
        </button>
      </div>

      <div class=" overflow-y-auto">
        <div class="p-[20px] flex flex-col gap-[16px]">
          <div>
            <div class="PC_Body2-R text-[#7C7379]">ผู้ลงข้อมูล</div>
            <div class="PC_Body1-R">{{ OfflineData?.profileData || '-'}}</div>
          </div>
          <div>
            <div class="PC_Body2-R text-[#7C7379]">วันที่ และเวลาที่แก้ไขล่าสุด</div>
            <div class="PC_Body1-R">{{ formatThaiDate(OfflineData.updated_at) }}</div>
            <!-- 04/12/2568, 15:05 -->
          </div>
        </div>
      </div>

      <!-- Pagination -->
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onBeforeUnmount, onMounted } from "vue";
import { useShelterStore } from "@/pinia/shelter";

const shelterStore = useShelterStore();

const props = defineProps({
});

const modalOpened = ref(false);
const OfflineData = ref()

const openModal = (data) => {
  console.log(data);
  
  OfflineData.value = data
  modalOpened.value = true;
};

const closeModal = () => {
  modalOpened.value = false;
  //   document.body.style.overflow = "auto";
};

function formatThaiDate(dateString) {
  const date = new Date(dateString)

  // แปลงเป็นเวลาไทย
  const thaiDate = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Bangkok' }))

  const day = String(thaiDate.getDate()).padStart(2, '0')
  const month = String(thaiDate.getMonth() + 1).padStart(2, '0')
  const year = thaiDate.getFullYear() + 543

  const hours = String(thaiDate.getHours()).padStart(2, '0')
  const minutes = String(thaiDate.getMinutes()).padStart(2, '0')

  return `${day}/${month}/${year}, ${hours}:${minutes}`
}

// const emit = defineEmits(["close"]);
defineExpose({ openModal });
</script>
